import { ENV_PRODUCTION } from "../../constants/environment";

export default function resolveApiUrl(environment) {
  if (environment === ENV_PRODUCTION) {
    return process.env.REACT_APP_API_URL;
  } else {
    return process.env.REACT_APP_SANDBOX_API_URL;
  }
}
